"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
exports.default = (faces) => {
    const geom = new THREE.Geometry();
    let vertexOffset = 0;
    faces.forEach(face => {
        face.vertices.forEach(v => geom.vertices.push(v));
        if (face.vertices.length == 3) {
            const tf = new THREE.Face3(vertexOffset, vertexOffset + 1, vertexOffset + 2, face.normal);
            // TODO can probably have lookup on THREE colours as going to be tiny set with consistent string keys
            tf.color = new THREE.Color(face.colour);
            geom.faces.push(tf);
            vertexOffset += 3;
        }
        else if (face.vertices.length == 4) {
            const tf1 = new THREE.Face3(vertexOffset, vertexOffset + 1, vertexOffset + 2, face.normal);
            const tf2 = new THREE.Face3(vertexOffset, vertexOffset + 2, vertexOffset + 3, face.normal);
            // TODO can probably have lookup on THREE colours as going to be tiny set with consistent string keys
            tf1.color = new THREE.Color(face.colour);
            tf2.color = new THREE.Color(face.colour);
            geom.faces.push(tf1);
            geom.faces.push(tf2);
            vertexOffset += 4;
        }
        else {
            throw new Error("Can only work with 3 or 4 edged faces");
        }
    });
    return new THREE.Mesh(geom, new THREE.MeshPhysicalMaterial({
        side: THREE.FrontSide,
        vertexColors: THREE.FaceColors
    }));
};



// WEBPACK FOOTER //
// ./src/components/three/convertFaces.ts